// extracted by mini-css-extract-plugin
export default {"main":"AboutMeComponent_main__hij3f","flash":"AboutMeComponent_flash__xUlnu"};